<script lang="ts" context="module">
	import type { schema } from "$lib/editor/schema";
	import DynamicBlockReplacer from "./DynamicBlockReplacer.svelte";
	import type { StaticBlockWithDynamicBlockReplacer } from "./types";
	import { getJson } from "$lib/components/http";
	import { blocksConfig } from "$lib/editor/app/blocks/blocksConfig";
	import { getClassicWebUrl } from "$lib/components/currentUser";
</script>

<script lang="ts">
	export let newsletter: schema.Newsletter;
	export let hasPolls: boolean = false;
	export let allowTableOfContent: boolean;

	const CLASSIC_WEB_URL = getClassicWebUrl();

	async function handlePolls(replacer: StaticBlockWithDynamicBlockReplacer) {
		try {
			const polls = await getJson<(schema.PollBlock & { myAnswerIds: string[] })[]>(
				`${CLASSIC_WEB_URL}/app/polls/get_all/${newsletter.id}`
			);

			polls.forEach((poll) => {
				// await new Promise((resolve) => setTimeout(resolve, 20000));
				replacer(newsletter, poll, blocksConfig.poll.render);
			});
		} catch (e) {
			console.error(e);
		}
	}
</script>

{#if hasPolls}
	<DynamicBlockReplacer {newsletter} blockHandler={handlePolls} {allowTableOfContent} />
{/if}
